<div class="container-fluid">
    <div class="row no-gutters position-relative" [formGroup]="metricsForm">
        <div class="col-2">
            <mat-form-field appearance="fill">
                <mat-label>Start Date</mat-label>
                <input matInput 
                    [matDatepicker]="startDate" 
                    formControlName="startDate" 
                    [max]="metricsForm.get('endDate').value">
                <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                <mat-datepicker #startDate></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="col-2">
            <mat-form-field appearance="fill">
                <mat-label>End Date</mat-label>
                <input matInput 
                    [matDatepicker]="endDate" 
                    formControlName="endDate"
                    [min]="metricsForm.get('startDate').value" 
                    [max]="todaysDate"
                    [disabled]="metricsForm.get('startDate')?.hasError('required')">
                <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                <mat-datepicker #endDate></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="col-2 packageCategory">
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>Select Region-Category</mat-label>
                <mat-select formControlName="regionCategory" multiple>
                    <mat-select-trigger>
                        {{metricsForm.value.regionCategory ? metricsForm.value.regionCategory[0] : ''}}
                        <span *ngIf="metricsForm.value.regionCategory?.length > 1 && !metricsForm.value.regionCategory?.includes('All')">
                            (+{{metricsForm.value.regionCategory.length - 1}})
                        </span>
                        <span *ngIf="metricsForm.value.regionCategory?.includes('All')">
                            (+{{metricsForm.value.regionCategory.length - 2}})
                        </span>
                    </mat-select-trigger>
                    <mat-option #matOption (click)="changeRegionCategory(matOption)" [value]="'All'">Select All</mat-option>
                    <mat-option #matOption (click)="changeRegionCategory(matOption)" [value]="option.region + '-' + option.category" *ngFor="let option of locations">{{ option.region }}-{{option.category}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-1 ml-auto mr-4">
            <button class="btn btn-primary" [disabled]="metricsForm.invalid" (click)="onSubmit()">
                Submit
            </button>
        </div>
    </div>
    <div class="bg-light">
        <table class="table">
            <thead>
                <tr>
                    <th class="text-center">Metric</th>
                    <th class="text-center">Primary</th>
                    <th class="text-center">Secondary</th>
                    <th class="text-center">BIB</th>
                    <th class="text-center">Variety Pack</th>
                    <th class="text-center">Multi-Lang <span class="smalltext"> (Not included in Total)</span></th>
                    <th class="text-center">Total</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="text-center">Total No Of Packages</td>
                    <td class="text-center">{{metricsData?.primaryPackage?.totalNumberOfPackage || 0}}</td>
                    <td class="text-center">{{metricsData?.secondaryPackage?.totalNumberOfPackage || 0}}</td>
                    <td class="text-center">{{metricsData?.bibPackage?.totalNumberOfPackage || 0}}</td>
                    <td class="text-center">{{metricsData?.varietyPackage?.totalNumberOfPackage || 0}}</td>
                    <td class="text-center">{{metricsData?.multiLangPackage?.totalNumberOfPackage || 0}}</td>
                    <td class="text-center">{{metricsData?.totalCount?.totalNumberOfPackage || 0}}</td>
                </tr>
                <tr>
                    <td class="text-center">Successful Package Count</td>
                    <td class="text-center">{{metricsData?.primaryPackage?.successfulPackage || 0}}</td>
                    <td class="text-center">{{metricsData?.secondaryPackage?.successfulPackage || 0}}</td>
                    <td class="text-center">{{metricsData?.bibPackage?.successfulPackage || 0}}</td>
                    <td class="text-center">{{metricsData?.varietyPackage?.successfulPackage || 0}}</td>
                    <td class="text-center">{{metricsData?.multiLangPackage?.successfulPackage || 0}}</td>
                    <td class="text-center">{{metricsData?.totalCount?.successfulPackage || 0}}</td>
                </tr>
                <tr>
                    <td class="text-center">Failed Package Count</td>
                    <td class="text-center">{{metricsData?.primaryPackage?.failedPackage || 0}}</td>
                    <td class="text-center">{{metricsData?.secondaryPackage?.failedPackage || 0}}</td>
                    <td class="text-center">{{metricsData?.bibPackage?.failedPackage || 0}}</td>
                    <td class="text-center">{{metricsData?.varietyPackage?.failedPackage || 0}}</td>
                    <td class="text-center">{{metricsData?.multiLangPackage?.failedPackage || 0}}</td>
                    <td class="text-center">{{metricsData?.totalCount?.failedPackage || 0}}</td>
                </tr>
                <tr>
                    <td class="text-center">Unique User Count</td>
                    <td class="text-center">{{metricsData?.primaryPackage?.uniqueUser || 0}}</td>
                    <td class="text-center">{{metricsData?.secondaryPackage?.uniqueUser || 0}}</td>
                    <td class="text-center">{{metricsData?.bibPackage?.uniqueUser || 0}}</td>
                    <td class="text-center">{{metricsData?.varietyPackage?.uniqueUser || 0}}</td>
                    <td class="text-center">{{metricsData?.multiLangPackage?.uniqueUser || 0}}</td>
                    <td class="text-center">{{metricsData?.totalCount?.uniqueUser || 0}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>